<template>
    <basic-screen>
        <template v-slot:appLogoLeft>
            <v-btn v-if="displayNavigationDrawerHamburgerIcon" @click="toggleNav" icon><v-icon>mdi-menu</v-icon></v-btn>
        </template>
        <template slot="appBarCenter">
            <router-link :to="{ name: `default${boardType}board` }">{{ $t('admin.back-to-board') }}</router-link>
        </template>
        <div class="d-flex flex-row flex-nowrap flex-grow-1">
            <navigation-drawer :key="rerenderKey" :is-user-admin="isUserAdmin" :is-sandpit-manager="isSandpitManager" v-model="showNavigationDrawer"></navigation-drawer>

            <div style="flex-grow: 1">
                <router-view />
                <div class="mt-5" v-if="$route.query.superadmin">
                    <h1>{{ $t('admin.super-admin') }}</h1>
                    <v-btn @click="fixUsers">{{ $t('admin.fix-users') }}</v-btn>
                </div>
            </div>
        </div>

    </basic-screen>
</template>
<script>
import ShiftStore from '@/lib/stores/CurrentShiftStore';
import Security, { Roles } from '@/lib/Security';
import Admin from '@/lib/data/Admin';
import BasicScreen from '@/templates/BasicScreen.vue';
import { EventBus, Events } from '@/lib/EventBus';
import NavigationDrawer from '@/components/Admin/NavigationDrawer.vue';
export default {
    components: {
        NavigationDrawer,
        BasicScreen
    },
    data() {
        return {
            boardType: ShiftStore.selectedBoardType,
            isUserAdmin: false,
            isSandpitManager: false,
            rerenderKey: 0,
            showNavigationDrawer: this.$vuetify.breakpoint.mdAndUp,
        };
    },
    created() {
        this.isUserAdmin = Security.hasRole(Roles.UserAdministrator);
        this.isSandpitManager = Security.hasRole(Roles.SandpitManager);
        EventBus.$on(Events.TermsUpdated, this.refreshNavigationTerms);
        EventBus.$on(Events.ScreenResized, this.refreshNavigationMenuVisibility);
    },
    destroyed() {
        EventBus.$off(Events.TermsUpdated, this.refreshNavigationTerms);
        EventBus.$off(Events.ScreenResized, this.refreshNavigationMenuVisibility);
    },
    computed: {
        displayNavigationDrawerHamburgerIcon() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    methods: {
        async fixUsers() {
            await Admin.fixUsers();
        },
        refreshNavigationTerms() {
            this.rerenderKey = this.rerenderKey + 1;
        },
        toggleNav() {
            this.showNavigationDrawer = !this.showNavigationDrawer;
        },
        refreshNavigationMenuVisibility({ width }) {
            if (!this.$vuetify.breakpoint.smAndDown && width < this.$vuetify.breakpoint.thresholds.sm) {
                this.showNavigationDrawer = false;
            } else if(!this.$vuetify.breakpoint.mdAndUp && width >= this.$vuetify.breakpoint.thresholds.sm) {
                this.showNavigationDrawer = true;
            }
        }
    }
};
</script>
